module.exports = __webpack_public_path__ + "media/components/app-store/static/s4-78cf0f784ef8127885e471fe376e6eaa.jpg";